module.exports = __webpack_public_path__ + "static/media/Noirden-Regular.c3af58eb.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-Regular.eot
// module id = 2941
// module chunks = 68